const l = {
  name: "Blog",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 38" style="enable-background:new 0 0 40 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M40,2H0V0h40V2z"/>
		<path class="st0" d="M0,8h40V6H0V8z"/>
		<path class="st0" d="M40,14H0v-2h40V14z"/>
		<path class="st0" d="M0,18h25.7c0.9-0.6,2-1,3.1-1c1.1,0,2.2,0.4,3.1,1H40v2h-6.5c0.3,0.7,0.5,1.4,0.5,2.2c0,0.6-0.1,1.2-0.3,1.8
			H40v2h-7.6l-4,4H40v2H26.4l-6,6H0v-2h13v-4H0v-2h13.6l4-4H0v-2h19.6l4-4H0V18z M25.9,20.5l4.6,4.6l0.6-0.6
			c0.1-0.1,0.1-0.1,0.2-0.2c0.5-0.6,0.8-1.3,0.8-2.1c0-0.9-0.4-1.7-0.9-2.3c-0.1-0.1-0.1-0.1-0.2-0.2l0,0l0,0
			c-0.6-0.5-1.3-0.8-2.1-0.8c-0.8,0-1.5,0.3-2.1,0.8l0,0l0,0c-0.1,0-0.1,0.1-0.2,0.2L25.9,20.5z M24.5,21.9L15,31.4V36h4.6l9.5-9.5
			L24.5,21.9z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Blog
};
